import { common } from './assets/common';
import React from 'react';
import clsx from 'clsx';
import styles from './Icon.module.scss';

interface IIconProps {
  className?: string;
  type: DesignSystemIconType;
  altText?: string;
}

/**
 * 디자인 시스템의 아이콘
 * @see https://www.figma.com/file/UCKulsei4QcUxxGxECOXiU/01.-Yanolja-Design-Kit?node-id=1003-8883
 */
export type DesignSystemIconType =
  | 'gnbhome_selected_h48'
  | 'icon_add'
  | 'icon_add_fill'
  | 'icon_alarm'
  | 'icon_area'
  | 'icon_arrowback'
  | 'icon_arrowback_fill'
  | 'icon_arrowdrop_fill'
  | 'icon_arrowdrop_fill_nomargin'
  | 'icon_arrowforward_fill'
  | 'icon_arrowforward_fill_nomargin'
  | 'icon_arrowleft_fill'
  | 'icon_arrowleft_fill_nomargin'
  | 'icon_arrowless_fill'
  | 'icon_arrowmore_fill'
  | 'icon_arrowoneway'
  | 'icon_arrowright_fill'
  | 'icon_arrowright_fill_nomargin'
  | 'icon_arrowup_fill'
  | 'icon_arrowup_fill_nomargin'
  | 'icon_bed'
  | 'icon_bus'
  | 'icon_bus_fill'
  | 'icon_calendar'
  | 'icon_calendarcheck'
  | 'icon_calendarcheck_fill'
  | 'icon_camera'
  | 'icon_category'
  | 'icon_category_fill'
  | 'icon_cart'
  | 'icon_cart_h72'
  | 'icon_chatbot'
  | 'icon_chatbot_h32'
  | 'icon_clock'
  | 'icon_close'
  | 'icon_convenience'
  | 'icon_coupon'
  | 'icon_coupon-1'
  | 'icon_coupon_fill'
  | 'icon_coupon_h72'
  | 'icon_dayuse'
  | 'icon_delete'
  | 'icon_delete_fill'
  | 'icon_done'
  | 'icon_edit'
  | 'icon_edit_fill'
  | 'icon_enter'
  | 'icon_error'
  | 'icon_error_fill'
  | 'icon_error_h72'
  | 'icon_face'
  | 'icon_failover_h72'
  | 'icon_faq'
  | 'icon_faq_h32'
  | 'icon_favorite'
  | 'icon_favorite_fill'
  | 'icon_favorite_fill_grayshadow'
  | 'icon_favorite_fill_yapinkshadow'
  | 'icon_favorite_h72'
  | 'icon_filter'
  | 'icon_flight'
  | 'icon_flight_fill'
  | 'icon_gift'
  | 'icon_gift_fill'
  | 'icon_help'
  | 'icon_help_fill'
  | 'icon_helpdesk'
  | 'icon_helpdesk_h32'
  | 'icon_home'
  | 'icon_home_fill'
  | 'icon_info'
  | 'icon_info_fill'
  | 'icon_insertphoto'
  | 'icon_krw_fill'
  | 'icon_landmark'
  | 'icon_leisure'
  | 'icon_leisure_fill'
  | 'icon_list'
  | 'icon_list_h72'
  | 'icon_location'
  | 'icon_location_fill'
  | 'icon_locker_fill'
  | 'icon_logout'
  | 'icon_mail'
  | 'icon_map'
  | 'icon_menu'
  | 'icon_mic'
  | 'icon_more'
  | 'icon_my'
  | 'icon_my_fill'
  | 'icon_mylocation'
  | 'icon_nearme'
  | 'icon_nearme_fill'
  | 'icon_nearmecircle_fill'
  | 'icon_nearmehelp'
  | 'icon_neutral_fill'
  | 'icon_neutral_fill_nomargin'
  | 'icon_note'
  | 'icon_notice'
  | 'icon_notice_h32'
  | 'icon_notification'
  | 'icon_notification_fill'
  | 'icon_notification_h72'
  | 'icon_parking'
  | 'icon_pause'
  | 'icon_pause_fill'
  | 'icon_pause_fill_whiteshadow'
  | 'icon_phone'
  | 'icon_play'
  | 'icon_play_fill'
  | 'icon_play_fill_whiteshadow'
  | 'icon_point'
  | 'icon_property'
  | 'icon_refresh'
  | 'icon_registration'
  | 'icon_remove'
  | 'icon_restaurant'
  | 'icon_review'
  | 'icon_save'
  | 'icon_search'
  | 'icon_search_h72'
  | 'icon_setting'
  | 'icon_share'
  | 'icon_smokefree'
  | 'icon_sorting'
  | 'icon_star'
  | 'icon_star_fill'
  | 'icon_star_fill_yayellow'
  | 'icon_star_fill_yayellowh44'
  | 'icon_star_yayellow'
  | 'icon_star_yayellowh44'
  | 'icon_subdirectory'
  | 'icon_subway'
  | 'icon_subway_fill'
  | 'icon_switchairplane'
  | 'icon_ticket'
  | 'icon_train'
  | 'icon_train_fill'
  | 'icon_trashcan'
  | 'icon_vacation'
  | 'icon_visibilityoff'
  | 'icon_visibilityon'
  | 'icon_volumeoff'
  | 'icon_volumeoff_fill'
  | 'icon_volumeoff_fill_whiteshadow'
  | 'icon_volumeon'
  | 'icon_volumeon_fill'
  | 'icon_vr'
  | 'icon_ycoin';

/**
 * 디자인 시스템 아이콘. 크기는 `font-size`, 색상은 `color`로 조절.
 */
const IconCommon: React.FC<IIconProps> = ({ className, type, altText }) => {
  return (
    <span
      className={clsx(styles.icon, className)}
      aria-hidden={!altText}
      dangerouslySetInnerHTML={{ __html: common[type] }}
      aria-label={altText}
      title={altText}
    />
  );
};

export default IconCommon;
